import { Resource } from '@prismamedia/one-crud-react';

export const BlocksConfig: Resource = {
  singular: 'block',
  plural: 'blocks',
  basePath: 'blocks',
  keyProperty: 'id',
  isRelationEnity: true,
};
